
import store from "../store";
import { serviceDietitianDashboardConsultationHistory } from "../services/DietitianDashboard.service";

export const FETCH_INIT = 'FETCH_INIT_CONSULTATION_HISTORY';
export const FETCHED = 'FETCHED_CONSULTATION_HISTORY';
export const FETCHED_FAIL = 'FETCHED_FAIL_CONSULTATION_HISTORY';
export const SET_SORTING = 'SET_SORTING_CONSULTATION_HISTORY';
export const SET_FILTER = 'SET_FILTER_CONSULTATION_HISTORY';
export const CHANGE_PAGE = 'CHANGE_PAGE_CONSULTATION_HISTORY';
export const SET_SERVER_PAGE = 'SET_SERVER_PAGE_CONSULTATION_HISTORY';
export const SET_ROW_SIZE = 'SET_ROW_SIZE_CONSULTATION_HISTORY';
export const RESET_FILTER = 'RESET_FILTER_CONSULTATION_HISTORY';
export const CLEAN = 'CLEAN_CONSULTATION_HISTORY';
export const RESET_TABLE_DATA = 'RESET_TABLE_DATA_CONSULTATION_HISTORY';

export function actionFetchConsultationHistory(pageId = 0, sorting = {}, filter = {}) {
    const stateData = store.getState().dietitian_consultation_history;
    const rowSize = stateData?.rowsPerPage || 10;

    const request = serviceDietitianDashboardConsultationHistory({
        pageId: pageId, // 0-based pageId
        row: rowSize,
        order: sorting?.order,
        sort_by: sorting?.row,
        ...filter,
    });

    return (dispatch) => {
        dispatch({ type: FETCH_INIT, payload: null });
        request.then((data) => {
            dispatch({ type: SET_FILTER, payload: filter });
            dispatch({ type: SET_SORTING, payload: sorting });
            if (!data.error) {
                dispatch({ type: FETCHED, payload: { data: data?.data, page: pageId } });
                dispatch({ type: SET_SERVER_PAGE, payload: pageId });
                if (pageId === 0) {
                    dispatch({ type: CHANGE_PAGE, payload: 0 });
                }
            } else {
                dispatch({ type: FETCHED_FAIL, payload: null });
            }
        });
    };
}

export function actionSetPageConsultationHistory(page, extraPayload) {
    const stateData = store.getState().dietitian_consultation_history;
    const totalLength = stateData.all.length;
    const sortingData = stateData.sorting_data;
    const filter = stateData.filter;
    const serverPage = stateData.serverPage || 0;
    const rowsPerPage = stateData.rowsPerPage || 10;

    // Check if we need to fetch more data
    if (totalLength <= ((page + 1) * rowsPerPage)) {
        const nextPage = serverPage + 1;
        const payload = {
            ...extraPayload,
            pageId: nextPage,
            row: rowsPerPage,
        };
        delete payload.index;
        store.dispatch(actionFetchConsultationHistory(nextPage, sortingData, { ...filter, ...payload }));
    }
    return { type: CHANGE_PAGE, payload: page };
}

export function actionSetRowSizeConsultationHistory(value) {
    return { type: SET_ROW_SIZE, payload: value };
}

export function actionCleanConsultationHistory() {
    return { type: CLEAN, payload: null };
}

export function actionResetConsultationHistoryTable() {
    return { type: RESET_TABLE_DATA, payload: null };
}
export function actionResetFilterConsultationHistory() {
    return { type: RESET_FILTER, payload: null };
}